import { Directive, HostListener, ElementRef } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { fromEvent } from "rxjs";
import { debounceTime, take } from "rxjs/operators";

@Directive({
  selector: "[appInvalidControlScroll]",
})
export class InvalidControlScrollDirective {
  constructor(
    private el: ElementRef,
    private formGroupDirective: FormGroupDirective
  ) {}

  // directive will works when submit any form

  @HostListener("ngSubmit") onSubmit() {
    if (this.formGroupDirective.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  // method to scroll to the first invalid input with smoothy scrolling
  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector(".ng-invalid");

    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth",
    });
    // if we need to focus on the input field

    // fromEvent(window, 'scroll')
    //   .pipe(debounceTime(100), take(1))
    //   .subscribe(() => firstInvalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
}
